import { FlexBox } from "@brg/ui";
import styled, { css, keyframes } from "styled-components";

export const FadeOut = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
`;

export const FadeIn = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

export const PopUpWrapper = styled.div<{ positionX?: number | null, positionY?: number | null, visible?: boolean, fs?: boolean, blueSelect?: boolean  }>`
    display: flex;
    max-height: 200px;
    position: absolute;
    top: ${({ blueSelect, positionY }) => blueSelect ? (positionY ? `${positionY + 45}px` : '45px') : (positionY ? `${positionY + 15}px` : '20px')};
    left: ${({ positionX }) => positionX ? `${positionX}px` : 0};
    z-index: 999999;
    user-select: none;
    transition: visibility 0s ${({ visible }) => visible ? '0s' : '0.2s'};
    
    ${({ visible }) => visible ? css`
        visibility: visible;
        pointer-events: auto;
        animation: ${FadeIn} 0.2s linear forwards;
    ` : css`
        visibility: hidden;
        pointer-events: none;
        opacity: 0;
    `};
`;

export const PopUpContent = styled.div`
    max-width: 450px;
    width: max-content;
    max-height: 200px;
    height: 100%;
    padding: 16px 24px 16px 24px;
    // padding: 16px 8px 4px 24px;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    // border-radius: 8px;
    user-select: none;
    // background-color: ${({ theme }) => theme.hoverModal.bg.color};
    display: inline-flex;
    position: relative;
    overflow-y: scroll;

    flex-wrap: wrap;

    ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.hoverModal.scroll.bg};
        border-radius: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: inherit;
    }
        
`;

export const TagsGridWrapper = styled.div`
  display: inline-flex;
  position: relative;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;
  max-width: max-content;
  max-height: 100%;

`;

export const PopupOuter = styled(FlexBox)`
  flex-flow: row;
  background-color: ${({ theme }) => theme.hoverModal.bg.color};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  margin-top: 15px;
  border-radius: 8px;
`;

export const PopUpFakeContainer = styled.div`
  border-radius: 8px;
  width: 5px;
`;import { FlexBox } from "@brg/ui";
import styled, { css, keyframes } from "styled-components";

export const FadeOut = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
`;

export const FadeIn = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

export const PopUpWrapper = styled.div<{ positionX?: number | null, positionY?: number | null, visible?: boolean, fs?: boolean, blueSelect?: boolean  }>`
    display: flex;
    max-height: 200px;
    position: absolute;
    top: ${({ blueSelect, positionY }) => blueSelect ? (positionY ? `${positionY + 45}px` : '45px') : (positionY ? `${positionY + 15}px` : '20px')};
    left: ${({ positionX }) => positionX ? `${positionX}px` : 0};
    z-index: 999999;
    user-select: none;
    transition: visibility 0s ${({ visible }) => visible ? '0s' : '0.2s'};
    
    ${({ visible }) => visible ? css`
        visibility: visible;
        pointer-events: auto;
        animation: ${FadeIn} 0.2s linear forwards;
    ` : css`
        visibility: hidden;
        pointer-events: none;
        opacity: 0;
    `};
`;

export const PopUpContent = styled.div`
    max-width: 450px;
    width: max-content;
    max-height: 200px;
    height: 100%;
    padding: 16px 24px 16px 24px;
    // padding: 16px 8px 4px 24px;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    // border-radius: 8px;
    user-select: none;
    // background-color: ${({ theme }) => theme.hoverModal.bg.color};
    display: inline-flex;
    position: relative;
    overflow-y: scroll;

    flex-wrap: wrap;

    ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.hoverModal.scroll.bg};
        border-radius: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: inherit;
    }
        
`;

export const TagsGridWrapper = styled.div`
  display: inline-flex;
  position: relative;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;
  max-width: max-content;
  max-height: 100%;

`;

export const PopupOuter = styled(FlexBox)`
  flex-flow: row;
  background-color: ${({ theme }) => theme.hoverModal.bg.color};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  margin-top: 15px;
  border-radius: 8px;
`;

export const PopUpFakeContainer = styled.div`
  border-radius: 8px;
  width: 5px;
`;